import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Card, Header, Form, Input, Button} from 'semantic-ui-react';
import {dateFormatPicker, reverseShortDate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Loader from '../../../common/components/loader';
import Table from './Table';
import './styles.scss';

class ReportCombos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'start': moment().startOf('month').format(reverseShortDate),
      'end': moment().format(reverseShortDate),
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.ReportCombos,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.handleSearch();
  }

  handledDowloadReport = () => {
    const {start, end} = this.state;
    this.props.getCombosReportDataExcel(start, end);
  };

  handleChange = (field, value) => {
    this.setState({
      [field]: moment(value).format(reverseShortDate),
    });
  };

  handleSearch = () => {
    const {start, end} = this.state;
    this.props.getCombosReportData(start, end);
  };

  render() {
    const {start, end} = this.state;
    const {loading, data} = this.props;

    if (loading) {
      return <Loader />;
    }

    return (
      <div>
        <Card raised fluid className='container-report-combos'>
          <div className='container-report-combos-header'>
            <Header as='h2'>Reporte Combos</Header>

            <div className='container-report-combos-controls'>
              <Form.Input
                fluid
                label='Fecha Inicial'
                className='report-combos-label'
              >
                <DatePicker
                  customInput={<Input icon='calendar' size='small' />}
                  placeholderText='Fecha incial'
                  className='report-combos-datepicker'
                  selected={
                    start ? moment(start, reverseShortDate).toDate() : null
                  }
                  maxDate={moment(end, reverseShortDate).toDate()}
                  dateFormat={dateFormatPicker}
                  onChange={(value) => this.handleChange('start', value)}
                  locale='es'
                />
              </Form.Input>
              <Form.Input
                fluid
                label='Fecha Final'
                className='report-combos-label'
              >
                <DatePicker
                  customInput={<Input icon='calendar' size='small' />}
                  placeholderText='Fecha final'
                  className='report-combos-datepicker'
                  selected={end ? moment(end, reverseShortDate).toDate() : null}
                  minDate={moment(start, reverseShortDate).toDate()}
                  dateFormat={dateFormatPicker}
                  onChange={(value) => this.handleChange('end', value)}
                  locale='es'
                />
              </Form.Input>
              <div className='report-combos-btn'>
                <Button onClick={this.handleSearch} color='blue'>
                  Buscar
                </Button>
              </div>
              <div className='report-combos-btn'>
                <Button onClick={this.handledDowloadReport} color='green'>
                  Descargar Excel
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className='container-report-combos-table'>
          <Table dataTable={data} />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.combosReportData.loading,
    'data': state.combosReportData.data,
  };
};

const {navigateTo, getCombosReportData, getCombosReportDataExcel} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  getCombosReportData,
  getCombosReportDataExcel,
})(ReportCombos);
